import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
// import { TextField } from "@mui/material";

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  classes: PropTypes.string,
};

export default function RHFTextField({ name, label, type, classes,outerClasses, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error, isDirty } }) => (
        <>
        <div className={outerClasses}>
          <label htmlFor="#id" className="capitalize text-left block mb-4 font-[500]  ">
            {label}
          </label>
          <input
            {...field}
            id="id"
            fullWidth
            type={type}
            value={
              typeof field.value === "number" && field.value === 0
                ? ""
                : field.value
            }
            error={!!error}
            className={` ${
              error && "invalid "
            } ${
              isDirty &&
              !error &&
              "outline-green-400 outline-2 border-transparent"
            } rounded  w-full p-2 px-4 focus:outline-blue-400 focus:bg-white focus:border-transparent   focus:shadow-blue-400 border bg-slate-50 outline-none ${classes}`}
            {...other}
          />

       
        </div>
        <p className="text-red-400 mt-2">{error?.message}</p>
        </>
      )}
    />
  );
}
